import _ from 'lodash'

export const getComments = (state) => (id) => {
  return _.uniqBy(state.localDiscussions[id].comments, 'id')
}

export const getDiscussionPosition = (state) => (id) => {
  if (state.localDiscussions[id]) {
    return state.localDiscussions[id].position || 'bottom'
  } else return 'bottom'
}

export const getDiscussionDraftComment = (state) => (id) => {
  if (state.localDiscussions[id]) {
    return state.localDiscussions[id].comment || null
  } else return null
}
